import React, { useContext } from "react";
import InteractionsTable from "./Interactionstable";
import { Button, Space } from "antd";
import { context } from "../../context/context";

const Interactions = () => {
    const {setIsInteractionModalOpen}=useContext(context)
  return (
    <>
      <Space
        direction="vertical"
        style={{ width: "100%", justifyContent: "space-between" }}
        align="end"
      >
        <Button onClick={()=>{setIsInteractionModalOpen(true)}} type="primary">ساخت پیامک جدید</Button>
      </Space>

      <InteractionsTable />
    </>
  );
};

export default Interactions;
